// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2.00406 0.590088L1.99991 0.585938L0.585693 2.00015L3.54649 4.96094C1.95638 6.86844 0.999756 9.3225 0.999756 12C0.999756 18.0751 5.92462 23 11.9998 23C14.6773 23 17.1313 22.0434 19.0388 20.4533L21.9999 23.4144L23.4098 22.0045L1.99976 0.594389L2.00406 0.590088ZM5.28003 11.3908L8.67179 10.0862L13.9138 15.3282L12.6093 18.72L10.6712 13.3288L5.28003 11.3908Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.6028 17.369C22.4925 15.781 22.9998 13.9497 22.9998 12C22.9998 5.92487 18.0749 1 11.9998 1C10.05 1 8.21879 1.50726 6.63079 2.397L12.7511 8.51729L17.19 6.81L15.4827 11.2489L21.6028 17.369Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-explore-off-filled')
export default class ExploreOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'explore-off-filled',
    }
  }
}
